import React from "react";
import { Card } from "react-bootstrap";
import "./TestimonialCard.css";

const TestimonialCard = ({
  name,
  role,
  product,
  review,
  imageSrc,
  variantClass,
}) => {
  // CORRECTED: Updated version to 9.x / 10.x and added proper URL query formatting
  const randomAvatarUrl = `https://api.dicebear.com/9.x/adventurer/svg?seed=${encodeURIComponent(name)}`;

  // Fallback pattern: Use imageSrc if provided, otherwise fallback to the random generated face
  const finalImageSrc = imageSrc || randomAvatarUrl;

  return (
    <Card className={`testimonial-user-card h-100 ${variantClass}`}>
      <Card.Body className="d-flex flex-column align-items-center text-center p-4">
        {/* Avatar Image */}
        <div className="avatar-wrapper">
          <img src={finalImageSrc} alt={name} className="avatar-img" />
        </div>

        {/* User Info */}
        <h3 className="user-name">{name}</h3>
        <p className="user-role">{role}</p>

        {/* Product Tagline */}
        <p className="product-bought">
          <span className="product-name"> Product bought: {product}</span>
        </p>

        {/* Review Quote Text */}
        <p className="review-text mt-2">“{review}”</p>
      </Card.Body>
    </Card>
  );
};

export default TestimonialCard;